import Button from "react-bootstrap/Button";
import type { ModalProps } from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { Lightbox } from "components/Lightbox";
import TeacherEvaluationUploadForm from "./TeacherEvaluationUploadForm";
import { useState } from "react";
import { useToken } from "./useToken";

interface Props {
  className?: string;
  onHide: () => void;
  onSubmit: () => void;
  show: boolean;
  size?: ModalProps["size"];
  userAssignmentId: string;
}

// AIDEV-NOTE: `ariaLabel`, ne `bodyTitleId` — `TeacherEvaluationUploadForm` vykresluje
// `<h1>{t("uploadTitle")}</h1>` jen ve výchozím stavu formuláře; při nahrávání/úspěchu/chybě
// (viz jeho `switch`) nadpis ze stromu zmizí a `aria-labelledby` by mířilo do prázdna. Navíc
// ten formulář žije i mimo lightbox (`pages/TeacherEvaluationUpload`), takže se nesahá na jeho
// nadpis kvůli tomuhle převodu. Jméno bere stejný klíč, který si formulář vizuálně zobrazuje —
// `uploadTitle`. [TD-344]
const TeacherEvaluationUploadModal: React.FC<Props> = ({
  className,
  onHide,
  onSubmit,
  show,
  size = "lg",
  userAssignmentId,
}) => {
  const { t } = useTranslation("teacherEvaluation");
  const token = useToken();
  const [isUploaded, setIsUploaded] = useState(false);

  const handleSuccess = () => {
    setIsUploaded(true);
  };

  if (token === null) return null;

  return (
    <Lightbox
      show={show}
      onHide={onHide}
      size={size}
      className={`modal--exercise ${className ?? ""}`}
      ariaLabel={t("uploadTitle")}
      bodyClassName="pb-60px pt-20px px-80px"
    >
      <div className={"qr-block mb-20px"}>
        <TeacherEvaluationUploadForm onSuccess={handleSuccess} token={token} userAssignmentId={userAssignmentId} />
      </div>

      <div className="d-grid gap-8px">
        <Button variant="primary" className={"w-100 text-uppercase"} disabled={!isUploaded} onClick={onSubmit}>
          {t("buttonPhotoConfirm")}
        </Button>
        <Button variant="outline-secondary" className={"w-100 text-uppercase"} onClick={onHide}>
          {t("close")}
        </Button>
      </div>
    </Lightbox>
  );
};

export default TeacherEvaluationUploadModal;
